import { BILLING_DATA_TYPES } from '../../models/BillingData';

const getBillingDataType = (type) => {
  switch (type) {
    case 1:
      return BILLING_DATA_TYPES.PERSONALID;
    case 2:
      return BILLING_DATA_TYPES.RUT;
    case 10:
      return BILLING_DATA_TYPES.OTHER;
    default:
      return null;
  }
};

class BillingDataSerializer {
  static deSerialize(data) {
    return {
      id: String(data.DFWId),
      type: getBillingDataType(data.DFWTipoDocumento),
      name: data.DFWNombre,
      address: data.DFWDireccion,
      rut: data.DFWCiRut,
      personalId: data.DFWCiRut,
      locality: data.DFWLocalidad,
      department: data.DFWDepartamento,
    };
  }

  static deSerializNewApi(data) {
    return {
      id: String(data.id),
      type: getBillingDataType(data.documentType),
      name: data.name,
      address: data.address,
      rut: data.rut,
      personalId: data.rut,
      locality: data.locality,
      department: data.department,
    };
  }
}

export { BillingDataSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/BillingDataSerializer.js